import axios from "axios";
import config from "@Config/index";
import type { EditorialPageData } from "../types";

const getEditorialPageData = async (): Promise<EditorialPageData> => {
  const res = await axios.get(`${config.CMS_API_URL}/api/editorial-page-data`);
  return res.data?.data;
};

export default getEditorialPageData;
